module.exports = __webpack_public_path__ + "img/apple-pay.0471c8c5.png";